/**
 * A Random Number Generator (RNG) function that takes an optional seed value.
 * - Uses a linear congruential generator (LCG) algorithm.
 * - `m` is the modulus, set to 2^35 - 31.
 * - `a` is the multiplier, set to 185852.
 * - `s` is the seed value, initialized to the provided seed modulo `m`.
 *
 * @param {object} seed - the seed value for the random number generator. Math.random() does not support seeds.
 * @returns {function} - returns a random number generator that produces values between 0 and 1.
 */
export const randomNumberGenerator = (seed = Date.now()) => {
  var m = 2 ** 35 - 31;
  var a = 185852;
  var s = seed % m;
  return function () {
    return (s = (s * a) % m) / m;
  };
};
